import React from 'react';

const Video = () => (
  <div>
    <h2>Product Video</h2>
    <video width="600" controls>
      <source src="/public/cd.mp4" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  </div>
);

export default Video;
